import React from 'react';

interface Props {
	name: string;
	value: string | number;
	onClick?: () => void;
}
const Option: React.FC<Props> = (props) => {
	return (
		<option value={props.value} onClick={props.onClick}>
			{props.name}
		</option>
	);
};
export default Option;
